import { render, staticRenderFns } from "./PanelTernium.vue?vue&type=template&id=62542f0c&"
import script from "./PanelTernium.vue?vue&type=script&lang=js&"
export * from "./PanelTernium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports